//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


const selectore = (state) => {
    return state.notifications
};
export const useNotifications = () => {
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}
